export default __webpack_public_path__ + "static/media/colour icons.9e364fcb.textClipping";